import apiFetch from '../apiFetch'

export default function (idAlbaranManual) {
  return apiFetch({endPoint: `AlbaranManual/eliminarAlbaran?idAlbaranManual=` + idAlbaranManual, method: 'GET', body: null})
}
